import * as Yup from 'yup';

export const updateNameSchema = Yup.object({
	formValue: Yup.string()
		.trim()
		.min(5, 'Name must be at least 5 characters')
		.max(255, 'Name must be maximum 255 characters')
		.required('Required'),
});
